// bpmn-js writes its renderer's default colors into each shape's inline style,
// so CSS variables work there and follow theme changes without re-importing
// the diagram. The variables are defined in src/styles/theme.css. Colors set
// on individual elements in the BPMN XML still take precedence.
export const BPMN_RENDERER_THEME = {
  defaultFillColor: "var(--diagram-node-fill)",
  defaultStrokeColor: "var(--diagram-node-stroke)",
  defaultLabelColor: "var(--diagram-node-label)",
};

// A downloaded SVG is opened outside the app, where the variables don't
// exist, so exports get bpmn-js's own (light) defaults written in.
const EXPORT_COLORS = {
  "var(--diagram-node-fill)": "white",
  "var(--diagram-node-stroke)": "hsl(225, 10%, 15%)",
  "var(--diagram-node-label)": "hsl(225, 10%, 15%)",
};

export function withPortableBpmnColors(svg) {
  if (!svg) return svg;
  return Object.entries(EXPORT_COLORS).reduce(
    (out, [variable, color]) => out.split(variable).join(color),
    svg,
  );
}
